import { openModal } from '@core/components/ModalStack';
import { Subject } from 'rxjs';
import { EmailTemplateModalData, EmailTemplateModalProps } from './EmailTemplateModal';

export function openEmailTemplateModal(props: Omit<EmailTemplateModalProps, 'onSubmit' | 'onCancel'>) {
  const obs$ = new Subject<EmailTemplateModalData>();

  const onSubmit = (data: EmailTemplateModalData) => {
    obs$.next(data);
    obs$.complete();
  };

  const onCancel = () => {
    obs$.error(new Error('No account select'));
  };

  import('./EmailTemplateModal').then(module => openModal(module.EmailTemplateModal, { ...props, onSubmit, onCancel }));

  return obs$;
}
